import React from 'react';
import { useState, useEffect } from 'react';
import {getCompletedRaces} from '../services/api';
import {ResultList} from '../components/Lists';
import { RenderDashboardHeader, WaitForData } from '../components/RenderUtils';


const ResultListPage=() =>{
  const [loading,setLoading] = useState(true);
  const [result,setResult] = useState([]);
  useEffect( () => {
    getCompletedRaces()
        .then (t=> {setResult(t); setLoading(false)})
  },[]);
    //console.log(result);
    if (loading) {
      return (
        <>
        <RenderDashboardHeader subtext="Resultater"/>
        <WaitForData show={loading}/>
        </>
      );

    }
    else {

    return (
      <>
      <RenderDashboardHeader maintext={result.event.name} subtext="Resultater"/>
      <ResultList races={result.races}/> 
      </>
    );
    }
}

export default ResultListPage;
